module.exports = __webpack_public_path__ + "static/media/starter_unscharf.925a91e5.jpg";